<div class="flex-column flex-middle">
    <div class="ratio-1-1"
         [style.width.em]="5.8">
        <img class="rf"
             image="{{recommendation | optionImage: 'fashion_recommendation'}}">
    </div>
    <p class="p2 col-1 m-t-7">{{recommendation | optionLabel: 'fashion_recommendation'}}</p>
</div>
